import React, { useState, useEffect } from "react";
import { API } from "../constants";

const BlogAdmin = ({ t, renderMarkdown, accent, setPage, setSelectedBlogPost }) => {
  const [secret, setSecret] = useState(() => sessionStorage.getItem("admin_secret") || "");
  const [saveSecret, setSaveSecret] = useState(!!sessionStorage.getItem("admin_secret"));
  const [topic, setTopic] = useState("");
  const [genPost, setGenPost] = useState(null);
  const [working, setWorking] = useState(false);
  const [activeTab, setActiveTab] = useState("editor"); // editor | manage
  const [previewMode, setPreviewMode] = useState(false);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    if (saveSecret) sessionStorage.setItem("admin_secret", secret);
    else sessionStorage.removeItem("admin_secret");
  }, [secret, saveSecret]);

  const fetchPosts = async () => {
    try {
      const res = await fetch(`${API}/api/blog`);
      const data = await res.json();
      setPosts(data);
    } catch (e) {
      console.error("Failed to fetch posts");
    }
  };

  useEffect(() => {
    if (activeTab === "manage") {
      fetchPosts();
    }
  }, [activeTab]);

  const generate = async () => {
    setWorking(true);
    try {
      const res = await fetch(`${API}/api/admin/generate-post`, {
        method: "POST",
        body: JSON.stringify({ secret, topic })
      });
      const data = await res.json();
      if (data.success) {
        setGenPost(data.post);
        setPreviewMode(false);
      }
      else alert(data.error);
    } catch (e) { alert("Failed"); }
    setWorking(false);
  };

  const save = async () => {
    setWorking(true);
    try {
      const res = await fetch(`${API}/api/admin/save-post`, {
        method: "POST",
        body: JSON.stringify({ secret, post: genPost })
      });
      const data = await res.json();
      if (data.success) { 
        alert("Published!"); 
        setGenPost(null); 
        setTopic(""); 
        setActiveTab("manage");
        fetchPosts();
      }
      else alert(data.error);
    } catch (e) { alert("Failed"); }
    setWorking(false);
  };

  const deletePost = async (id) => {
    if (!window.confirm("Are you sure you want to delete this post?")) return;
    setWorking(true);
    try {
      const res = await fetch(`${API}/api/admin/delete-post`, {
        method: "POST",
        body: JSON.stringify({ secret, id })
      });
      const data = await res.json();
      if (data.success) {
        fetchPosts();
      } else {
        alert(data.error);
      }
    } catch (e) { alert("Failed"); }
    setWorking(false);
  };

  const hidePost = async (id) => {
    if (!window.confirm("Are you sure you want to hide this system post?")) return;
    setWorking(true);
    try {
      const res = await fetch(`${API}/api/admin/hide-post`, {
        method: "POST",
        body: JSON.stringify({ secret, id })
      });
      const data = await res.json();
      if (data.success) {
        fetchPosts();
      } else {
        alert(data.error);
      }
    } catch (e) { alert("Failed"); }
    setWorking(false);
  };

  const editPost = (post) => {
    setGenPost(post);
    setActiveTab("editor");
    setPreviewMode(false);
  };

  const suggestTopic = async () => {
    setWorking(true);
    try {
      const res = await fetch(`${API}/api/admin/suggest-topic`, { method: "POST", body: JSON.stringify({ secret }) });
      const data = await res.json();
      if (data.success) setTopic(data.suggestion);
      else alert(data.error);
    } catch(e) { alert("Failed"); }
    setWorking(false);
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto", fontFamily: "'Plus Jakarta Sans',sans-serif", color: t.text }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" }}>
        <h2 style={{ fontSize: "28px", fontWeight: 800, fontFamily: "'Bricolage Grotesque',sans-serif" }}>Blog Admin</h2>
        <div style={{ display: "flex", gap: "15px" }}>
          <button onClick={() => setActiveTab("editor")} style={{ background: activeTab === "editor" ? accent : "transparent", color: activeTab === "editor" ? "#fff" : t.text, border: `1.5px solid ${activeTab === "editor" ? accent : t.border}`, padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontWeight: 600 }}>Editor</button>
          <button onClick={() => setActiveTab("manage")} style={{ background: activeTab === "manage" ? accent : "transparent", color: activeTab === "manage" ? "#fff" : t.text, border: `1.5px solid ${activeTab === "manage" ? accent : t.border}`, padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontWeight: 600 }}>Manage Posts</button>
        </div>
      </div>

      <div className="card" style={{ marginBottom: "30px", background: t.card }}>
        <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
          <input type="password" placeholder="Admin Secret" value={secret} onChange={e => setSecret(e.target.value)} style={{ flex: 1, marginBottom: 0 }} />
          <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", color: t.text2, cursor: "pointer", whiteSpace: "nowrap", fontWeight: 600 }}>
            <input type="checkbox" checked={saveSecret} onChange={e => setSaveSecret(e.target.checked)} style={{ width: "16px", height: "16px" }} /> Remember Me
          </label>
        </div>
      </div>

      {activeTab === "editor" && (
        <div>
          {!genPost ? (
            <div className="card" style={{ background: t.card }}>
              <h3 style={{ marginBottom: "15px", fontSize: "18px", color: t.text }}>Generate New Post</h3>
              <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
                 <input type="text" placeholder="What should the article be about?" value={topic} onChange={e => setTopic(e.target.value)} style={{ flex: 1, marginBottom: 0 }} />
                 <button className="btn-ghost" onClick={suggestTopic} disabled={working} style={{ whiteSpace: "nowrap", padding: "0 20px" }}>🪄 Suggest Topic</button>
              </div>
              <button className="btn-primary" onClick={generate} disabled={working || !topic.trim() || !secret} style={{ width: "100%", padding: "16px" }}>{working ? "Generating..." : "Generate Draft"}</button>
            </div>
          ) : (
            <div className="card" style={{ background: t.card }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <h3 style={{ fontSize: "20px", color: t.text, fontWeight: 800 }}>Review & Edit Draft</h3>
                <button onClick={() => setPreviewMode(!previewMode)} style={{ background: "transparent", border: `1.5px solid ${t.border}`, color: t.text2, padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}>
                  {previewMode ? "✏️ Switch to Edit Mode" : "👁️ Switch to Preview Mode"}
                </button>
              </div>

              {!previewMode ? (
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  <div>
                    <label style={{ display: "block", fontSize: "12px", color: t.text3, marginBottom: "6px", fontWeight: 700, letterSpacing: "0.5px" }}>URL SLUG (ID)</label>
                    <input type="text" value={genPost.id} onChange={e => setGenPost({...genPost, id: e.target.value})} style={{ marginBottom: 0 }} />
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: "12px", color: t.text3, marginBottom: "6px", fontWeight: 700, letterSpacing: "0.5px" }}>TITLE</label>
                    <input type="text" value={genPost.title} onChange={e => setGenPost({...genPost, title: e.target.value})} style={{ marginBottom: 0, fontWeight: 700, fontSize: "18px" }} />
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: "12px", color: t.text3, marginBottom: "6px", fontWeight: 700, letterSpacing: "0.5px" }}>EXCERPT (META DESCRIPTION)</label>
                    <textarea value={genPost.excerpt} onChange={e => setGenPost({...genPost, excerpt: e.target.value})} style={{ width: "100%", background: t.inputBg, border: `1.5px solid ${t.inputBorder}`, borderRadius: "9px", padding: "14px", color: t.text, fontSize: "14px", fontFamily: "'Plus Jakarta Sans',sans-serif", minHeight: "80px", outline: "none" }} />
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: "12px", color: t.text3, marginBottom: "6px", fontWeight: 700, letterSpacing: "0.5px" }}>CONTENT (MARKDOWN)</label>
                    <textarea value={genPost.content} onChange={e => setGenPost({...genPost, content: e.target.value})} style={{ width: "100%", background: t.inputBg, border: `1.5px solid ${t.inputBorder}`, borderRadius: "9px", padding: "14px", color: t.text, fontSize: "14px", fontFamily: "monospace", minHeight: "400px", outline: "none", lineHeight: 1.6 }} />
                  </div>
                </div>
              ) : (
                <div style={{ padding: "30px", border: `1.5px solid ${t.border}`, borderRadius: "12px", background: t.bg }}>
                  <h1 style={{ fontFamily: "'Bricolage Grotesque',sans-serif", fontSize: "32px", fontWeight: 800, color: t.text, lineHeight: 1.2, marginBottom: "24px" }}>{genPost.title}</h1>
                  <p style={{ color: t.text3, fontSize: "16px", fontStyle: "italic", borderLeft: `4px solid ${accent}`, paddingLeft: "16px", marginBottom: "30px" }}>{genPost.excerpt}</p>
                  <div style={{ color: t.text2, fontSize: "16px", lineHeight: 1.8 }}>
                    {renderMarkdown(genPost.content)}
                  </div>
                </div>
              )}

              <div style={{ display: "flex", gap: "12px", marginTop: "30px", borderTop: `1.5px solid ${t.border}`, paddingTop: "24px" }}>
                <button className="btn-primary" onClick={save} disabled={working} style={{ flex: 1, padding: "14px" }}>{working ? "Publishing..." : "🚀 Publish Live"}</button>
                <button className="btn-ghost" onClick={() => setGenPost(null)} disabled={working} style={{ padding: "14px 24px" }}>🗑️ Discard Draft</button>
              </div>
            </div>
          )}
        </div>
      )}

      {activeTab === "manage" && (
        <div className="card" style={{ background: t.card }}>
          <h3 style={{ marginBottom: "20px", fontSize: "20px", color: t.text, fontWeight: 800 }}>Published Posts</h3>
          {posts.length === 0 ? (
            <p style={{ color: t.text3, fontSize: "15px", padding: "20px 0" }}>No posts found.</p>
          ) : (
            <div style={{ display: "grid", gap: "12px" }}>
              {posts.map(p => (
                <div key={p.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", border: `1.5px solid ${t.border}`, borderRadius: "12px", background: t.bg }}>
                  <div>
                    <h4 style={{ fontSize: "16px", fontWeight: 700, color: t.text, marginBottom: "6px" }}>{p.title}</h4>
                    <div style={{ fontSize: "13px", color: t.text3, display: "flex", gap: "12px", alignItems: "center" }}>
                      <span>📅 {p.date}</span>
                      <span style={{ background: p.isCustom ? "rgba(109,40,217,0.1)" : "rgba(16,185,129,0.1)", color: p.isCustom ? accent : "#10B981", padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: 700 }}>
                        {p.isCustom ? "CUSTOM" : "SYSTEM"}
                      </span>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <button onClick={() => {
                      setSelectedBlogPost(p);
                      setPage("blog-post");
                    }} style={{ background: "transparent", border: `1.5px solid ${t.border}`, color: t.text2, padding: "6px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: 600, cursor: "pointer" }}>View</button>
                    
                    <button onClick={() => editPost(p)} style={{ background: "transparent", border: `1.5px solid ${t.border}`, color: t.text2, padding: "6px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: 600, cursor: "pointer" }}>Edit</button>

                    {p.isCustom ? (
                      <button onClick={() => deletePost(p.id)} disabled={working} style={{ background: "rgba(220,38,38,0.1)", border: "none", color: "#dc2626", padding: "6px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: 700, cursor: "pointer" }}>Delete</button>
                    ) : (
                      <button onClick={() => hidePost(p.id)} disabled={working} style={{ background: "rgba(107,114,128,0.1)", border: "none", color: t.text3, padding: "6px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: 700, cursor: "pointer" }}>Hide</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BlogAdmin;
